import React, { Component } from "react";
import { startTimer } from "../../../../_utils";

export default class Toast extends Component {
  componentDidMount() {
    const { onClose, timeout } = this.props;
    if (timeout !== 0) {
      startTimer(onClose, +timeout);
    }
  }

  render() {
    const {
      type,
      image,
      title,
      timeout,
      onClose,
      message,
      onClick
    } = this.props;
    let _classes = [
      "iziToast",
      "iziToast-theme-light",
      "iziToast-animateInside",
      "iziToast-opened"
    ];
    let _title = null;
    let _icon = 'ico-success';
    if (type === "success") {
      _classes.push("iziToast-color-green");
      _title = "Success";
    }
    if (type === "info") {
      _classes.push("iziToast-color-blue");
      _title = "Information";
      _icon = "ico-info";
    }
    if (type === "warning") {
      _classes.push("iziToast-color-orange");
      _title = "Warning";
      _icon = "ico-warning";
    }
    if (type === "danger") {
      _classes.push("iziToast-color-red");
      _title = "Error";
      _icon = "ico-error";
    }
    if (image) {
      _classes.push("iziToast-layout2");
      _classes.push("iziToast-theme-dark");
      _title = title;
    }
    return (
      <div
        class="iziToast-capsule"
        style={{ height: "auto" }}
        ref={element => (this.element = element)}
        onMouseEnter={() => {
          timeout === 0 ? null : clearTimeout(this.element);
        }}
        onMouseLeave={() => {
          timeout === 0 ? null : startTimer(onClose, +timeout);
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <div className={_classes.join(" ")}>
          <div
            class="iziToast-body"
            style={{ paddingLeft: image ? "70px" : "33px" }}
          >
            <i className={`iziToast-icon ${_icon} revealIn`} />
            <div class="iziToast-texts">
              <strong
                class="iziToast-title slideIn"
                style={{ marginRight: "10px" }}
              >
                {_title}
              </strong>
              <p class="iziToast-message slideIn">{message}</p>
            </div>
            <div />
          </div>
          {image ? (
            <div
              class="iziToast-cover"
              style={{
                width: "70px",
                backgroundImage: `url(${image})`
              }}
            />
          ) : null}
          <button
            class="iziToast-close"
            onClick={event => {
              event.stopPropagation();
              onClose();
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Layout/ToastContainer/Toast/index.js